import * as React from 'react';
import { styled, Box } from '@mui/system';
import ModalUnstyled from '@mui/base/ModalUnstyled';
import {useEffect} from "react";

const StyledModal = styled(ModalUnstyled)`
  position: fixed;
  z-index: 1300;
  right: 0;
  bottom: 0;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Backdrop = styled('div')`
  z-index: -1;
  position: fixed;
  right: 0;
  bottom: 0;
  top: 0;
  left: 0;
  backdrop-filter: blur(3px);
  background-color: rgba(0, 0, 0, 0.5);
`;

const style = {
    bgcolor: '#FFFFFF',
    // border:"none",
    borderRadius:"16px",
    p: 2,
    px: 4,
    pb: 3,
    // width:1000
};

interface IModel {
    open : boolean,
    handleClose : () => void,
    Component : React.FC
}

export const Model = ({ open, handleClose, Component} : IModel) => {

    return (
        <div>
            <StyledModal
                open={open}
                onClose={handleClose}
                BackdropComponent={Backdrop}
            >
                <Box sx={style}>
                    <Component/>
                </Box>
            </StyledModal>
        </div>
    );
}